import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.component.html',
  styleUrls: ['./refund-policy.component.scss']
})
export class RefundPolicyComponent implements OnInit {

  navbarOpen = false;

  constructor() { }


  openNav() {
    this.navbarOpen = !this.navbarOpen;
  }


  ngOnInit(): void {
  }

}
